import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AccountClient, UserLoginDTO, UserTokenDTO } from '../models/models.swagger.generated';

@Injectable()
export class LoginProxy {
    constructor(
      private accountClient: AccountClient) {
    }

    public login(userName: string, password: string, twoFactorAuthenticationToken?: string): Observable<UserTokenDTO> {
      return this.accountClient.token(new UserLoginDTO({userName, password, grant_Type: 'password', client_Id: environment.apiClientId, twoFactorAuthenticationToken: twoFactorAuthenticationToken}));
    }

    public refreshTokenLogin(refreshToken: string): Observable<[string, string]> {
      return this.accountClient.token(new UserLoginDTO({grant_Type: 'refresh_token', client_Id: environment.apiClientId, refresh_Token: refreshToken}))
        .pipe(
          map((res: any) => [res.access_token, res.refresh_token])
      );
    }
}
